import { getOwnerId } from "../common/ReplicatedData";
export function StartGameActionValidator(data, context) {
    return context.gameLifecycleStage === 'Lobby' && context.host === getOwnerId(data) && context.players.hasEnoughPlayers();
}
export function StartGameActionEffect(data, context) {
    context.setGameLifecycleStage('Ingame');
}
//# sourceMappingURL=StartGameAction.js.map